import * as React from 'react';

export type useWidthProps = () => {
  ref: React.RefObject<HTMLDivElement>;
  width: number;
  getSize: () => void;
};

export const useWidth: useWidthProps = () => {
  const [width, setWidth] = React.useState(0);
  const ref = React.useRef<HTMLDivElement>(null);

  const getSize = (): void => {
    if (!ref.current) return;

    const newWidth = ref?.current?.getBoundingClientRect().width;
    setWidth(newWidth);
  };

  React.useEffect(() => {
    getSize();
    window.addEventListener('resize', getSize);
  }, []);

  return { ref, width, getSize };
};
